import { lazy } from "react";
import InfoAccount from "./InformazioniAccount";

const ContactTable = lazy(() => import("./ContactTable"));
const UserList = lazy(() => import("./UserList"));
const ContactCard = lazy(() => import("./ContactCard"));
const ContactDetails = lazy(() => import("./ContactDetails"));
const InfoPaziente = lazy(() => import("./InfoPaziente"));
const ElencoAcquisti = lazy(() => import("./ElencoAcquisti"));

const contactRoutes = [
  {
    path: "/contact/table",
    element: <ContactTable />,
  },
  {
    path: "/utenti",
    element: <UserList />,
  },
  {
    path: "/contact/card",
    element: <ContactCard />,
  },
  {
    path: "/contact/details",
    element: <ContactDetails />,
  },
  {
    path: "/info-account",
    element: <InfoAccount />,
  },
  {
    path: "/InfoPaziente/:id",
    element: <InfoPaziente />,
  },
  {
    path: "/ElencoAcquisti",
    element: <ElencoAcquisti />,
  },

];

export default contactRoutes;
